import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import ThirdPartyPasswordless from "supertokens-web-js/recipe/thirdpartypasswordless";
import LoginPage from "./pages/LoginPage";
import OtpPage from "./pages/OtpPage";
import SuccessFulLoginPage from "./pages/SuccessFulLoginPage";
import ThirdPartyCallbackScreen from "./pages/ThirdPartyCallbackScreen";
import LogoutPage from "./pages/LogoutPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MagicLinkConsumableComponent from "./component/MagicLinkConsumableComponent";
import NotFoundPage from "./component/NotFoundPage";
import {
  DEFAULT_REDIRECT_URL,
  PRAJAVANI_URL,
  REDIRECT_URL,
} from "./contant";
import UpdateEmailOrPhonePage from "./pages/UpdateEmailOrPhonePage";
import EmailUpdateOtpPage from "./pages/EmailUpdateOtpPage";
import { useCallback, useLayoutEffect, useState } from "react";
import LoaderComponent from "./component/LoaderComponent";
import validateClientAPI from "./api/auth/validateClient";
import PRAJAVANI_FAVICON from "./images/prajavani-favicon.ico";
import DH_FAVICON from "./images/dh-favicon.ico";
import ValidateClientErrorComponent from "./component/ValidateClientErrorComponent";

const baseURL = process.env.REACT_APP_BASE_URL;
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
SuperTokens.init({
  appInfo: {
    appName: "Testing",
    websiteDomain: baseURL,
    apiDomain: apiBaseURL,
  },
  clientType: "web",
  recipeList: [
    Session.init(),
    ThirdPartyPasswordless.init({
      override: {
        functions: (oI) => {
          return {
            ...oI,
            getThirdPartyAuthStateFromURL: (input) => {
              if (input.userContext.state) {
                return input.userContext.state;
              }
              return oI.getThirdPartyAuthStateFromURL(input);
            },
          };
        },
      },
      preAPIHook: async (context) => {
        // is the fetch config object that contains the header, body etc..
        let action = context.action;

        if (action === "THIRD_PARTY_SIGN_IN_UP") {
          if (context.userContext.id_token !== undefined) {
            if (typeof context.requestInit.body !== "string") {
              throw new Error("should not happen");
            }
            let body = JSON.parse(context.requestInit.body);

            body.redirectURIInfo = undefined;
            body.oAuthTokens = {
              id_token: context.userContext.id_token,
              access_token: context?.userContext?.access_token,
            };

            context.requestInit.body = JSON.stringify(body);
          }
        }
        let requestInit = context.requestInit;
        const redirectUrl = new URL(localStorage.getItem("callbackUrl")).origin;
        let headers = {
          ...requestInit.headers,
          redirectUrl,
        };
        requestInit = {
          ...requestInit,
          headers,
        };
        return { ...context, requestInit };
      },
    }),
  ],
});
function App() {
  const [isValidatingClient, setIsValidatingClient] = useState(true);

  const [isErrorValidatingClient, setIsErrorValidatingClient] = useState(false);

  const handleValidResponse = useCallback(function () {
    setIsValidatingClient(false);
  }, []);
  const handleError = useCallback(() => {
    setIsErrorValidatingClient(true);
  }, []);

  // Verify if the redirect url in query params is valid or not
  useLayoutEffect(() => {
    setIsValidatingClient(true);
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    const callbackUrl = queryParams.get(REDIRECT_URL)?.trim() || localStorage.getItem("callbackUrl");
    const link = document.querySelector("link[rel~='icon']");
    if (!callbackUrl) {
      setIsValidatingClient(false);
      return;
    }
    if (callbackUrl.toLowerCase().includes(PRAJAVANI_URL)) {
      document.title = "Prajavani";
      link.href = PRAJAVANI_FAVICON;
    } else {
      document.title = "Deccan Herald";
      link.href = DH_FAVICON;
    }
    validateClientAPI(callbackUrl, handleValidResponse, handleError);
  }, []);

  if(isErrorValidatingClient) return <ValidateClientErrorComponent errorMessage={"Client could not be validated, Please contact support."}/>
  if (isValidatingClient) return <LoaderComponent label={"Loading..."} />;
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="toaster-class"
      />
      <Routes>
        <Route
          path="/"
          element={
            <Navigate to={`/auth?${REDIRECT_URL}=${DEFAULT_REDIRECT_URL}`} />
          }
        />
        <Route
          path="/auth"
          element={<LoginPage />}
          errorElement={<NotFoundPage />}
        />
        <Route path="/auth/verify_otp" element={<OtpPage />} />
        <Route
          path="/auth/post_change_email"
          element={<EmailUpdateOtpPage />}
        />
        <Route
          path="/auth/post_change_phonenumber"
          element={<EmailUpdateOtpPage />}
        />
        <Route path="/auth/authenticate" element={<SuccessFulLoginPage />} />
        <Route
          path="/auth/callback/:provider"
          element={<ThirdPartyCallbackScreen />}
        />
        <Route path="/auth/verify" element={<MagicLinkConsumableComponent />} />
        <Route path="/auth/logout" element={<LogoutPage />} />
        <Route path="/auth/change_email" element={<UpdateEmailOrPhonePage />} />
        <Route path="/auth/change_phonenumber" element={<UpdateEmailOrPhonePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
